module.exports = __webpack_public_path__ + "img/DannyZada.855f80f3.jpg";